import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, Router } from '@angular/router';
import { of } from 'rxjs';
import { map } from 'rxjs/operators';

import { PlanningService } from '../services/planning.service';
import { PlanningStats } from '@app/shared';


@Injectable({
    providedIn: 'root'
})
export class PlanningStatsResolverService implements Resolve<PlanningStats> {

    constructor(
        private planningService: PlanningService,
        private router: Router,
    ) { }

    resolve(route: ActivatedRouteSnapshot) {
        const period = route.paramMap.get('period');

        if (period === null) {
            return of (new PlanningStats());
        }

        return this.planningService.stats(+period).pipe(
            map(stats => {
                if (stats) {
                    return stats;
                }
                this.router.navigate(['planning', 'wish-period-list']);
                return null;
            })
        );
    }
}
